const NoPage = () => {
    return <h1>Fehler: Seite nicht gefunden.</h1>;
};

export default NoPage;